import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnalyticsService } from './analytics.service';
import { TrackClickDirective } from './track-click.directive';

@NgModule({
  declarations: [TrackClickDirective],
  imports: [CommonModule],
  exports: [TrackClickDirective]
})
export class AnalyticsModule {
  public static forRoot() {
    return {
      ngModule: AnalyticsModule,
      providers: [AnalyticsService]
    };
  }
}
